module.exports = __webpack_public_path__ + "static/img/error-404.58f508a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/error-404.svg
// module id = 1191
// module chunks = 4